export default {

    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },

    payerNameContainer: {
        display: "flex",
        columnGap: "18px",
        alignItems: "end"
    },

    userName: {
        fontSize: "24px"
    },

    detailsContainer: {
        marginTop: "38px",
        marginBottom: "60px",
    },

    detailsLabel: {
        marginLeft: "8px",
        fontSize: "14px",
        fontWeight: "400",
        color: "#262626"
    },

    gapBetween: {
        marginBottom: "19px"
    },

    importantNotificationsContainer: {
        marginTop: "60px",
    },

    notificationStatus: {
        display: "flex",
        alignItems: "center",
        columnGap: "8px"
    },

    statusHeading: {
        fontWeight: "600",
        fontSize: "20px",
        lineHeight: "24px",
        margin: "0 0 5px 0"
    },

    horizontalLine: {
        marginTop: "40px",
        marginBottom: "40px",
    },

    iconContainer: {
        justifyContent: "flex-start"
    },

    actionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #262626",
        borderRadius: "80px",
        padding: "6px 22px",
    },

    actionDropdownLabel: {
        marginRight: "15px"
    },

    actionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-70px",
        top: "29px",
    },

    chartContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        marginTop: "40px",
    },

    activityHeader: {
        display: "flex",
        alignItems: "center",
        columnGap: "8px"
    },
}